/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContactDto
 */
export interface ContactDto {
    /**
     * Contact ID
     * @type {string}
     * @memberof ContactDto
     */
    id: string;
    /**
     * User ID who owns this contact
     * @type {string}
     * @memberof ContactDto
     */
    userId: string;
    /**
     * Contact user ID (patient or provider ID)
     * @type {string}
     * @memberof ContactDto
     */
    contactId: string;
    /**
     * Type of contact
     * @type {string}
     * @memberof ContactDto
     */
    contactType: ContactDtoContactTypeEnum;
    /**
     * Contact first name
     * @type {string}
     * @memberof ContactDto
     */
    firstName: string;
    /**
     * Contact last name
     * @type {string}
     * @memberof ContactDto
     */
    lastName: string;
    /**
     * Contact photo URL
     * @type {string}
     * @memberof ContactDto
     */
    photoUrl?: string;
    /**
     * Practice name (for providers only)
     * @type {string}
     * @memberof ContactDto
     */
    practiceName?: string;
    /**
     * Practice ID (for providers only)
     * @type {string}
     * @memberof ContactDto
     */
    practiceId?: string;
    /**
     * Conversation ID if a conversation exists with this contact
     * @type {string}
     * @memberof ContactDto
     */
    conversationId?: string;
    /**
     * Created at timestamp
     * @type {Date}
     * @memberof ContactDto
     */
    createdAt: Date;
}


/**
 * @export
 */
export const ContactDtoContactTypeEnum = {
    Patient: 'patient',
    Provider: 'provider'
} as const;
export type ContactDtoContactTypeEnum = typeof ContactDtoContactTypeEnum[keyof typeof ContactDtoContactTypeEnum];


/**
 * Check if a given object implements the ContactDto interface.
 */
export function instanceOfContactDto(value: object): value is ContactDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('contactId' in value) || value['contactId'] === undefined) return false;
    if (!('contactType' in value) || value['contactType'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function ContactDtoFromJSON(json: any): ContactDto {
    return ContactDtoFromJSONTyped(json, false);
}

export function ContactDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': json['userId'],
        'contactId': json['contactId'],
        'contactType': json['contactType'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
        'practiceName': json['practiceName'] == null ? undefined : json['practiceName'],
        'practiceId': json['practiceId'] == null ? undefined : json['practiceId'],
        'conversationId': json['conversationId'] == null ? undefined : json['conversationId'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function ContactDtoToJSON(json: any): ContactDto {
    return ContactDtoToJSONTyped(json, false);
}

export function ContactDtoToJSONTyped(value?: ContactDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'contactId': value['contactId'],
        'contactType': value['contactType'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'photoUrl': value['photoUrl'],
        'practiceName': value['practiceName'],
        'practiceId': value['practiceId'],
        'conversationId': value['conversationId'],
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

